import React, { Component } from 'react';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import { Redirect } from 'react-router-dom';
import './Carts.scss'
import {Link} from 'react-router-dom'
import Icon from 'react-icons-kit';
import { arrowLeft } from 'react-icons-kit/fa/arrowLeft';
import { trash } from 'react-icons-kit/fa/trash';
import { ToastContainer, toast } from 'react-toastify';
import visamastercard from './../../../images/visa-mastercard.png';

class Cart extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loaderButton : false,
         loggedIn: false,
         loading:true,
         carts: [],
         cartSummary : [],
         orderId : null,
         paymentType : 0,
      };
      this.checkoutOrder = this.checkoutOrder.bind(this);
      this.removeItemCart = this.removeItemCart.bind(this);
      this.getItemCartSummary = this.getItemCartSummary.bind(this);
   }

   getItemCartSummary = async () => {
      console.log('getItemCart');
      let res = await axios.get(process.env.REACT_APP_API_HOST + "/cart/item-summary");
      console.log('res get itemcart ', res);
      if(res.data.cartSummary.grandTotal === 0){
         localStorage.removeItem('shopBubble');
         this.props.history.push("/cart");
      }
      this.setState({ cartSummary:res.data.cartSummary, loading:false });
   };

   removeItemCart = async (item) => {
      let res = await axios.delete(process.env.REACT_APP_API_HOST + '/cart/delete/'+item.id);
      console.log('res remove removeItemCart ', res);
      if(res.data.status === true){
         this.setState({carts: this.state.carts.filter(el => el !== item), loading:false });
         setTimeout(this.getItemCartSummary, 1000)
      } else {
         toast.error("Error! "+  res.data.error);
      }
   };
   
   checkoutOrder = async (e) => {
      e.preventDefault();
      this.setState({loaderButton:true})
      let data = {
         paymentType: this.state.paymentType
      }
      axios({
         method: 'POST',
         url: '/order/add',
         headers: {
            "Content-Type": "application/json"
         },
         data: data
      }).then(
         (response) => {
            console.log('response data chekoutOrder ', response.data);
            if(response.data.status === true){
               setTimeout(() => {
                  localStorage.removeItem('shopBubble');
                  this.props.history.push("/checkout/"+ response.data.data.id +"/thanks");
                  this.setState({orderId:response.data.data.id});
               }, 2000);
            } else {
               toast.error("Error! "+  response.data.error);
               setTimeout(() => {
                  this.setState({loaderButton:false})
               }, 1000);
            }
         },
         (error) => {
            toast.error("Error! "+  error);
            setTimeout(() => {
               this.setState({loaderButton:false})
            }, 1000);
         }
      );
   }
   
   componentDidMount() {
      const userData = localStorage.getItem("userData");
      if(userData){
         this.setState({loggedIn : true, companyName : JSON.parse(userData).data.companyName}) 
         axios.get(process.env.REACT_APP_API_HOST + '/cart/item')
         .then(res => {
            console.log('res.data ', res.data)
            if(res.data.carts.length === 0){
               localStorage.removeItem('shopBubble');
               this.props.history.push("/cart");
            }
            this.setState({ carts: res.data.carts, cartSummary:res.data.cartSummary, loading:false });
         })
      } 
   }
   
   render() {
      if(!localStorage.getItem('userData')){
         return (<Redirect to={'/'}/>)
      } 
      if(this.state.orderId){
         return (<Redirect to={'/checkout/' + this.state.orderId + '/thanks'}/>)
      } 
      return (
         <div className="nav-dashboard">
            <div className="nav second-nav shadow-bottom">
               <div className="container">
                  <div className="row">
                     <div className="col">
                        <div className="nav-page">
                           <Link to="/" className="btn-nav">
                              <Icon icon={arrowLeft} />
                           </Link>
                           <span className="page-title">Cart</span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div id="cartpage" className="content-page cart cp-85">
               <ToastContainer />
               <div className="container">
                  <div className="row">
                     <div className="col-sm-8">
                        <div className="overflow-x">
                        {this.state.scriptError}
                        {this.state.scriptLoaded}
                           <table className="table table-spaced" style={{marginTop:'-13px'}}>
                              <thead>
                                 <tr>
                                    <th className="icon">
                                       
                                    </th>
                                    <th>
                                       Program
                                    </th>
                                    <th align="right">
                                       <span className="float-right">Price /ton</span>
                                    </th>
                                    <th align="right">
                                       <span className="float-right">VCU</span>
                                    </th>
                                    <th align="right">
                                       <span className="float-right">Total</span>
                                    </th>
                                 </tr>
                              </thead>
                              <tbody>
                              {
                              this.state.carts.map((cart) => {
                                    return (
                                       <tr key={cart.id}>
                                          <td className="icon">
                                             <button className="btn btn-link-dark text-center btn-block" onClick={() => { this.removeItemCart(cart)}} key={cart.id}>
                                                <Icon icon={trash}/>
                                             </button>
                                          </td>
                                          <td className="td-program">
                                             <div className="row align-items-center">
                                                <div className="colprog col-auto">
                                                   <div className="img-thumb-wrap">
                                                      <img src={`https://dev.jejak.in/offset-query/file/program/${cart.featuredImage}`}  alt={cart.programName} className="img-thumb"/>
                                                   </div>
                                                </div>
                                                <div className="colprog col">
                                                   <h4 className="mt-0 mb-1">
                                                      {cart.programName}
                                                   </h4>
                                                   <small className="text-gray">
                                                      {cart.corporateName}
                                                   </small>
                                                </div>
                                             </div>
                                          </td>
                                          <td>
                                             <h4 className="mt-0 mb-0 float-right">
                                             {cart.currencySymbol} <NumberFormat value={cart.pricePerYear} displayType={'text'} thousandSeparator={true} decimalScale={0}/>
                                             </h4>
                                          </td>
                                          <td>
                                             <h4 className="mt-0 mb-0 float-right">
                                                {cart.totalVcu} <small>tonnes</small>
                                             </h4>
                                          </td>
                                          <td>
                                             <h4 className="mt-0 mb-0 float-right">
                                                <span className="text-green">{cart.currencySymbol} <NumberFormat value={cart.totalPrice} displayType={'text'} thousandSeparator={true} decimalScale={0}/></span>
                                             </h4>
                                          </td>
                                       </tr>
                                    )
                                 })
                              }
                                 
                              </tbody>
                           </table>
                        </div>
                     </div>
                     <div className="col-sm-4">
                        <div className="">
                           <div className="card shadow">
                              <div className="card-header">
                                 Order Summary
                              </div>
                              <div className="card-body pt-0">
                                 <div className="pt-3 pb-3 bb-thin">
                                    <div className="row">
                                       <div className="col-auto">
                                          <small>Total VCU (tonnes)</small>
                                       </div>
                                       <div className="col">
                                          <div className="float-right">
                                             <div className="txt-big text-black"><b>{this.state.cartSummary.vcu}</b></div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="pt-3 pb-3 bb-thin">
                                    <div className="row">
                                       <div className="col-auto">
                                          <small><b>Total Price</b></small>
                                       </div>
                                       <div className="col">
                                          <div className="float-right">
                                             <div className="txt-big text-orange"><b>{this.state.cartSummary.currencySymbol} <NumberFormat value={this.state.cartSummary.totalWithoutTax} displayType={'text'} thousandSeparator={true} decimalScale={0}/></b></div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="pt-3 pb-3 bb-thin">
                                    <div className="row">
                                       <div className="col-auto">
                                          <small>Tax</small>
                                       </div>
                                       <div className="col">
                                          <div className="float-right">
                                             <small><b>{this.state.cartSummary.currencySymbol}  <NumberFormat value={this.state.cartSummary.tax} displayType={'text'} thousandSeparator={true} decimalScale={0}/></b></small>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="pt-3 pb-3 bb-thin">
                                    <div className="row">
                                       <div className="col-auto">
                                          <small><b>Grand Total Price</b></small>
                                       </div>
                                       <div className="col">
                                          <div className="float-right">
                                             <div className="txt-big text-orange"><b>{this.state.cartSummary.currencySymbol} <NumberFormat value={this.state.cartSummary.grandTotal} displayType={'text'} thousandSeparator={true} decimalScale={0}/></b></div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <br/><br/>
                           <div className="card shadow">
                              <div className="card-header">
                                 Payment Option
                              </div>
                              <div className="card-body pt-0">
                                 {this.state.cartSummary.currency === 'IDR' ? (
                                    <div>
                                       <div className="mb-3">
                                          <input className="custom-radio custom-radio-green" id="pt0" name="paymenttype" type="radio" value="0" defaultChecked onClick={(e) => this.setState({paymentType: 0})}></input>
                                          <label className="custom-radio-label" htmlFor="pt0">
                                             <span>INVOICE</span>
                                             <div>Payment detail will send to your email</div>
                                          </label>
                                       </div>
                                       <div className="mb-3">
                                          <input className="custom-radio custom-radio-green" id="pt2" name="paymenttype" type="radio" value="2" onClick={(e) => this.setState({paymentType: 2})}></input>
                                          <label className="custom-radio-label" htmlFor="pt2">
                                             <span>MIDTRANS</span>
                                             <div>Credit Card, Bank Transfer (VA), GoPay</div>
                                          </label>
                                       </div>
                                       <div className="form-group mt-3 mb-2">
                                          <button type="submit" onClick={this.checkoutOrder} className="btn btn-orange btn-block">
                                          {this.state.loaderButton === true ? (
                                          <span><i className="fa fa-spin fa-spinner"></i> Waiting..</span>
                                       ) : ('CHECKOUT NOW')} 
                                          </button>
                                       </div>
                                    </div>
                                 ) : (
                                    <div>
                                       <div className="mb-3">
                                          <input className="custom-radio custom-radio-green" id="pt0" name="paymenttype" type="radio" value="0" defaultChecked onClick={(e) => this.setState({paymentType: 0})}></input>
                                          <label className="custom-radio-label" htmlFor="pt0">
                                             <span>INVOICE</span>
                                             <div>Payment detail will send to your email</div>
                                          </label>
                                       </div>
                                       <div className="mb-3">
                                          <input className="custom-radio custom-radio-green" id="pt1" name="paymenttype" type="radio" value="1" onClick={(e) => this.setState({paymentType: 1})}></input>
                                          <label className="custom-radio-label" htmlFor="pt1">
                                             <span>CREDIT CARD</span>
                                             <div>
                                                <img src={visamastercard} alt="Visa or Mastercard"  style={{width:'auto', height:'18px'}}/>
                                             </div>
                                          </label>
                                       </div>
                                       <div className="form-group mt-3 mb-2">
                                          <button type="submit" onClick={this.checkoutOrder} className="btn btn-orange btn-block">
                                          {this.state.loaderButton === true ? (
                                          <span><i className="fa fa-spin fa-spinner"></i> Waiting..</span>
                                       ) : ('CHECKOUT NOW')} 
                                          </button>
                                       </div>
                                    </div>
                                 ) }
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               
            </div>
         </div>
         )
      }
   }
   export default Cart;